<template>
  <div class="fw-600 p-3 mx-auto">
    <div class="info-card info-card--w600 info-card--one-col-text-only">
      <div class="info-card__body">
        <div
          class="info-card__header bg-light-gray p-2 info-card__header--one-col"
        >
          Image Guidelines
        </div>
        <div class="info-card__text--one-col">
          <p>
            To ensure the high quality we strive for in each of the products we
            publish, the images we select for publication must meet a few basic
            guidelines.
          </p>
          <p>
            If any one of your images meets all of the following criteria, the
            image has a very <strong>strong</strong> chance of being selected
            for a book or calendar!
          </p>
          <ul class="list">
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">
                Proper Image Size & Resolution
              </p>
              <p class="px-2">
                Remember, your photos will be used in
                <strong>print</strong> publications. So high resolution is key.
                And the dimensions - width and height, in pixels - must be high
                enough. We'd much rather work with a large image that can be
                scaled down as we build out a print project to preserve the
                image's quality (going the other way - enlarging a relatively
                small image - usually yields a poor image quality end-result).
              </p>
              <p class="px-2">
                Image should be a minimum of 1000px in height and width. 2000px
                and higher is better (the system will not accept an image that's
                less than 1000px wide).
              </p>
              <p class="px-2">
                The file size should be at least 2MB and no larger than 10MB
                (the system will not accept an image file that's more than 10MB
                in file size).
              </p>
              <p class="px-2">
                The good news is that the photos you take with modern smart
                phones and tablets will typically meet these requirements!
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">
                Orientation: Landscape or Portrait?
              </p>
              <p class="px-2">
                Both are okay, but we
                <span class="italic font-weight-bold">prefer</span> landscape
                photos: Image width is greater than the height.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">Good Composition</p>
              <p class="px-2">
                This is about how your photo is composed. The dog should be
                prominently featured in the image's foreground. If the image is
                otherwise great (excellent lighting, focused, perfect size,
                etc.) but the dog is set way back, we won't be selecting it.
              </p>
              <p class="px-2">
                And the photo should be a single image, i.e. no composite images
                or collages.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">Excellent Lighting</p>
              <p class="px-2">
                The subject and scene of your image should be well lit. The
                image overall should be bright and light (but not over-exposed).
                Images that are too dark will not be selected for projects.
                Sure, there's some processing we can do in Photoshop to lighten
                the image properly, but sometimes that can only go so far (not
                to mention that we likely will not apply photo enhancement to
                EVERY photo we select - we'd prefer to use images "as is" in
                most cases to conserve time and resources).
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">In Focus</p>
              <p class="px-2">
                Make sure your dog is clearly in focus. Blurry images will not
                be selected. This does NOT mean you can't have a "depth of
                field" effect where the background is slightly blurred. That is
                okay, as long as the dog is focused.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">
                Photo is Free of Overlays, Text, Graphics, etc.
              </p>
              <p class="px-2">
                The photo should be <strong>just</strong> a photo: No overlays,
                graphics, text labels, or other decoration or effects.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">
                Subject of Photo is a Dog (or Dogs)!
              </p>
              <p class="px-2">
                The image must be a photo of a <strong>dog</strong> (or two or
                more dogs)... Enough said! =) Oh, and no people should be in the
                photo.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">Let's See Your Dog's Face</p>
              <p class="px-2">
                The subject dog or dogs should be in a desirable pose. Now, we
                don't mean you have to literally and formally
                <span class="italic">pose</span> your dog in the perfect
                lying-down / sitting / standing position. The more "casual" your
                pup looks, the better in many cases. What we mean here is that
                we should see the dog's face - either facing the camera, a 3/4
                view, or even a profile can work. Photos with the dog's face
                blocked or not in the shot will not work.
              </p>
            </li>
            <li class="bg-very-light-gray">
              <p class="font-weight-bold mb-1">
                Text Description Matches Photo
              </p>
              <p class="px-2">
                The text you submit with your photo must "match" what's
                <span class="italic">in</span> the photo. In other words, if
                it's a photo of your toy poodle but you selected "German
                Shepherd" as the breed - probably by mistake, but still! -
                pretty good bet we'll be marking that pic as
                <span class="italic">Unusable</span>!
              </p>
            </li>
          </ul>
          <p>That's it! Pretty basic, really.</p>
          <p>
            Now grab your phone or tablet or digital camera, get your dog(s),
            get some fun pics, and get 'em uploaded here in Pixapup!
          </p>
        </div>
        <div class="image-wrapper image-wrapper--width-500">
          <img
            src="https://pixapup.com/wp-content/uploads/2020/12/taking-pic-dogBackGrass-mobile-phone-600w.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageImageGuidelines',
};
</script>

<style>
</style>